<template>
  <div class="lds-ripple">
    <div></div>
    <div></div>
  </div>
</template>

<style scoped>
.lds-ripple {
  display: inline-block;
  position: relative;
  width: 70px;
  height: 70px;
}

.lds-ripple div {
  position: absolute;
  border: 4px solid var(--couleur-accent);
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1.2s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}

@keyframes lds-ripple {
  0% {
    top: 31px;
    left: 31px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  4.9% {
    top: 31px;
    left: 31px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  5% {
    top: 31px;
    left: 31px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 62px;
    height: 62px;
    opacity: 0;
  }
}
</style>
